import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { useSatuEventTracker } from 'utils/satuEvent'

const SATU_EVENT_NAME = 'guru_skp_pelaksanaan_fe_user_action_v1'

type ScreenName = 'beranda_riwayat_kinerja' | 'detail_riwayat_kinerja'

type ActivityType =
  | 'click_cek_dokumen_evaluasi'
  | 'open_hasil_penilaian_kinerja'
  | 'open_detail_periode_riwayat_kinerja'
  | 'open_riwayat_kinerja'
  | 'click_selengkapnya_riwayat_kinerja'

interface SKPRiwayatTrackerParams {
  activity_type: ActivityType
  event_trigger?: ScreenName
  screen_name: ScreenName
  attributes?: Record<string, any>
}

type PeriodTrackerParams = { period: number; year: number }

const useSKPRiwayatTrackEvent = (periodParams?: PeriodTrackerParams) => {
  const { SETrackEvent, SETransformAttrs } = useSatuEventTracker()
  const { periodYear, periodNo } = usePeriodContext()

  const resolvedPeriod: PeriodTrackerParams = !!periodParams
    ? periodParams
    : { period: periodNo, year: periodYear }

  const trackEvent = (params: SKPRiwayatTrackerParams) => {
    SETrackEvent({
      eventName: SATU_EVENT_NAME,
      eventParams: {
        ...params,
        event_trigger: params.event_trigger ?? params.screen_name,
        attributes: SETransformAttrs({
          ...resolvedPeriod,
          ...params?.attributes,
        }),
        event_trace_id: '',
      },
      sendUserData: true,
      sendDefaultParams: true,
      sendAttributes: false,
    })
  }

  return {
    trackEvent,
  }
}

export default useSKPRiwayatTrackEvent
